import { useEffect, useState } from "react";
import "./styles/UserManagement.css";
import UserStatus from "../../components/UserStatus";
import DeatailUser from "../../components/DeatailUser";
import axios from "axios";
import edit from "/assets/icon/Edit.png";
import search from "/assets/icon/Search.svg";
import filter from "/assets/icon/Filter.svg";
import Ouh from "../../components/addUserForm";
import { Box, Typography } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";

function UserManagement() {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [showDetailUser, setShowDetailUser] = useState(false);
  const [showDetailUserWindow, setShowDetailUserWindow] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newUserId, setNewUserId] = useState(null);

  const handleConfirmButtonClick = () => {
    setIsAddUserModalOpen(false);
    sessionStorage.removeItem("newUser");
    sessionStorage.removeItem("selectedBrightness");
    sessionStorage.removeItem("toggleSwitchState");
    sessionStorage.removeItem("selectedItems");
  };

  const openAddUserModal = () => {
    setIsAddUserModalOpen(true);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleTdClick = (user) => {
    setSelectedUser(user);
    setShowDetailUser(true);
  };

  const handleTdClickEdit = (user) => {
    setSelectedUser(user);
    setShowDetailUserWindow(true);
  };

  const handleCloseDetailUser = () => {
    setShowDetailUser(false);
    setShowDetailUserWindow(false);
  };

  useEffect(() => {
    let isActive = true;
    async function fetchData() {
      try {
        const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/users`);
        if (isActive) {
          setUsers(response.data);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchData();
    return () => {
      isActive = false;
    };
  }, []);

  useEffect(() => {
    const filteredResults = users.filter(
      (user) =>
        user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.phone_no.includes(searchTerm) ||
        user.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredUsers(filteredResults);
  }, [searchTerm, users]);

  const reloadData = async (newId) => {
    try {
      const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/users`);
      setUsers(response.data);
      setNewUserId(newId);
    } catch (error) {
      console.error("Error reloading users:", error);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="containerPage">
      <br />
      <br />
      <h1 className="userManagement">การจัดการผู้ใช้งาน</h1>
      <div className="sectinoAddbuttom">
        <div className="search-bar">
          <img src={search} alt="search" className="search-user" />
          <input
            type="text"
            placeholder="ค้นหาชื่อ, หมายเลขโทรศัพท์, หรืออีเมล"
            value={searchTerm}
            onChange={handleSearch}
          />
          <div>
            <img src={filter} alt="filter" className="filter-user" />
          </div>
        </div>
        <button className="add_button" onClick={openAddUserModal}>
          + เพิ่มผู้ใช้งาน
        </button>
        {isAddUserModalOpen && (
          <Ouh
            onClose={handleConfirmButtonClick}
            onSuccess={(newId) => reloadData(newId)}
          />
        )}
        <div className="userTable">
          <span>มีผู้ใช้งานในระบบทั้งหมด</span>
          <span className="allBranches">{filteredUsers.length}</span>
          {currentItems.length === 0 ? (
            <Box
              mt={4}
              mb={4}
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="93%"
              height="200px"
              bgcolor="#344054"
              borderRadius="8px"
              flexDirection="column"
              color="#fff"
              p={3}
              sx={{ marginLeft: "50px" }}
            >
              <SearchOffIcon style={{ fontSize: 50, marginBottom: 16 }} />
              <Typography
                variant="h6"
                fontFamily='"IBM Plex Sans Thai", sans-serif'
              >
                ไม่มีข้อมูลที่ตรงกับการค้นหา
              </Typography>
            </Box>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>แก้ไข</th>
                  <th>No.</th>
                  <th>ชื่อ</th>
                  <th>หมายเลขโทรศัพท์</th>
                  <th>อีเมล</th>
                  <th>สาขาที่ดูแล</th>
                  <th>สถานะการใช้งาน</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((user, index) => (
                  <tr key={user.id}>
                    <td onClick={() => handleTdClickEdit(user)}>
                      <img src={edit} alt="edit" />
                    </td>
                    <td
                      className="relativTr"
                      onClick={() => handleTdClick(user)}
                    >
                      {indexOfFirstItem + index + 1}
                    </td>
                    <td onClick={() => handleTdClick(user)}>{user.name}</td>
                    <td onClick={() => handleTdClick(user)}>{user.phone_no}</td>
                    <td onClick={() => handleTdClick(user)}>{user.email}</td>
                    <td onClick={() => handleTdClick(user)}>
                      {user.branch_names}
                    </td>
                    <td className="w100" onClick={() => handleTdClick(user)}>
                      <div className="w150">
                        <UserStatus isOnline={user.active} />
                      </div>
                      {user.id === newUserId && (
                        <div className="new-badge">NEW</div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <div className="paginationUser">
            <div className="pagination">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                &laquo;
              </button>
              {Array.from({
                length: Math.ceil(filteredUsers.length / itemsPerPage),
              }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  className={currentPage === index + 1 ? "active" : ""}
                >
                  {index + 1}
                </button>
              ))}
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={
                  currentPage ===
                  Math.ceil(filteredUsers.length / itemsPerPage)
                }
              >
                &raquo;
              </button>
            </div>
          </div>
        </div>
      </div>
      {showDetailUser && (
        <DeatailUser userId={selectedUser.id} onClose={handleCloseDetailUser} />
      )}
      {showDetailUserWindow && (
        <DeatailUser
          userId={selectedUser.id}
          onClose={handleCloseDetailUser}
          openIsEditing={true}
          onSuccess={reloadData}
        />
      )}
    </div>
  );
}

export default UserManagement;
